"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcPopOverBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var common_constants_1 = require("../../../common/constants/common-constants");
var bc_pop_over_constants_1 = require("./bc-pop-over-constants");
var helpers_1 = require("../../../common/helpers");
var bc_location_builder_client_rect_utils_1 = require("../../../common/location-builder/location-builder-client-rect/bc-location-builder-client-rect-utils");
var bc_location_builder_position_1 = require("../../../common/location-builder/bc-location-builder-position");
var bc_location_builder_1 = require("../../../common/location-builder/bc-location-builder");
var bc_pop_over_location_1 = require("./bc-pop-over-location");
var bc_pop_over_models_1 = require("./bc-pop-over-models");
var BcPopOverBehavior = (function (_super) {
    __extends(BcPopOverBehavior, _super);
    function BcPopOverBehavior() {
        return _super.call(this) || this;
    }
    BcPopOverBehavior.setUpAll = function () {
        var popOverElements = Array.from(document.querySelectorAll("".concat(common_constants_1.BcCommonConstants.SECTION_TAG, "[class~='").concat(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER, "']")));
        var elements = [];
        for (var _i = 0, popOverElements_1 = popOverElements; _i < popOverElements_1.length; _i++) {
            var popOverElement = popOverElements_1[_i];
            var element = popOverElement;
            var bcPopOverBehavior = new BcPopOverBehavior();
            bcPopOverBehavior.setElement(element);
            bcPopOverBehavior.setUp();
            elements.push(bcPopOverBehavior);
        }
        return elements;
    };
    BcPopOverBehavior.prototype._setUp = function () {
        var _a, _b;
        this.bcContainer = this.mySelf.querySelector(".".concat(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_CONTAINER));
        this.localization = new bc_location_builder_client_rect_utils_1.LocationBuilderClientRectUtils();
        this.localizationBuilder = new bc_location_builder_1.BcLocationBuilder();
        this.elementPosition = new bc_location_builder_position_1.BcLocationBuilderPosition();
        this.idAttribute = this.mySelf.getAttribute(common_constants_1.BcCommonConstants.ID);
        this.target = document.querySelector("[".concat(common_constants_1.BcCommonConstants.ARIA_CONTROL, "=").concat(this.idAttribute, "]"));
        this.widthAttribute = this.mySelf.getAttribute(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_PROPERTY_WIDTH);
        this.typeWidth = (_a = this.mySelf.getAttribute(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_PROPERTY_TYPE_WIDTH)) !== null && _a !== void 0 ? _a : 'px';
        this.heightAttribute = this.mySelf.getAttribute(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_PROPERTY_HEIGHT);
        this.typeHeight = (_b = this.mySelf.getAttribute(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_PROPERTY_TYPE_HEIGHT)) !== null && _b !== void 0 ? _b : 'px';
        this.backdropAttribute = this.mySelf.getAttribute(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_PROPERTY_BACKDROP);
        this.fullScreenAttribute = this.mySelf.getAttribute(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_PROPERTY_FULLSCREEN);
        this.hiddenArrowAttribute = this.mySelf.getAttribute(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_PROPERTY_HIDDEN_ARROW);
        this.position = this.mySelf.getAttribute(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_POSITION);
        this.positionTablet = this.mySelf.getAttribute(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_POSITION_TABLET);
        this.positionMobile = this.mySelf.getAttribute(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_POSITION_MOBILE);
        this.setButtonClose();
        this.setScrollAttribute();
        this.setHover();
        this.setCloseOutside();
        this.arrowElement = (0, helpers_1.createElement)({ element: common_constants_1.BcCommonConstants.DIV_TAG, classList: [bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_ARROW] });
        this.listenerResize();
        this.listenerScroll();
        this.listenerCloseEventKey();
        this.setSizeMediaQuery(false);
        this.bcPopOverLocation = new bc_pop_over_location_1.BcPopOverLocation();
        var breakpointMD = getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-md');
        this.breakpointMD = Number(breakpointMD.slice(0, -common_constants_1.COMMON_CONSTANTS_NUMBERS.N2));
        var breakpointLG = getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-lg');
        this.breakpointLG = Number(breakpointLG.slice(0, -common_constants_1.COMMON_CONSTANTS_NUMBERS.N2));
        this.arrowPopover = document.createElement(common_constants_1.BcCommonConstants.SECTION_TAG);
        this.arrowPopover.classList.add(bc_pop_over_constants_1.BcPopOverConstans.ARROW_BC_POP_OVER);
    };
    BcPopOverBehavior.prototype.setButtonClose = function () {
        var buttonClose = this.mySelf.getAttribute(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_ATRIBUTE_BUTTON_CLOSE);
        if (buttonClose === bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_VALUE_TRUE) {
            this.createButonClose();
        }
    };
    BcPopOverBehavior.prototype.setScrollAttribute = function () {
        var _a;
        this.scrollAttribute = (_a = this.mySelf.getAttribute(common_constants_1.BcCommonConstants.SCROLL)) !== null && _a !== void 0 ? _a : bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_VALUE_TRUE;
        if (this.scrollAttribute === bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_VALUE_TRUE) {
            this.setScroll();
        }
    };
    BcPopOverBehavior.prototype.setCloseOutside = function () {
        this.closeOutsideAttribute = this.mySelf.getAttribute(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_PROPERTY_CLOSE_OUTSIDE);
        if (this.closeOutsideAttribute === bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_VALUE_TRUE) {
            this.listenerClickOut();
        }
    };
    BcPopOverBehavior.prototype.setHover = function () {
        this.hoverAttribute = this.mySelf.getAttribute(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_PROPERTY_HOVER);
        if (this.hoverAttribute === bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_VALUE_TRUE) {
            this.listenerMouseEnter();
            this.listenerMouseLeave();
        }
    };
    BcPopOverBehavior.prototype.setPosition = function () {
        if (this.position) {
            if ((screen.width <= this.breakpointMD) && this.positionMobile) {
                this.setManualPosition(this.positionMobile);
                return;
            }
            if ((screen.width > this.breakpointMD && screen.width < this.breakpointLG) && this.positionTablet) {
                this.setManualPosition(this.positionTablet);
                return;
            }
            this.setManualPosition();
        }
        else {
            this.setAutomaticPosition();
        }
    };
    BcPopOverBehavior.prototype.setManualPosition = function (positionPopover) {
        var _a;
        if (positionPopover === void 0) { positionPopover = this.position; }
        var position = this.bcPopOverLocation.getPositionPopOver(this.target, this.mySelf, positionPopover);
        if (position) {
            this.stilesPosition(position.x, position.y);
            if (this.hiddenArrowAttribute == 'false') {
                if (!this.mySelf.querySelector(".".concat(bc_pop_over_constants_1.BcPopOverConstans.ARROW_BC_POP_OVER))) {
                    this.mySelf.append(this.arrowPopover);
                }
                var options = (_a = {},
                    _a[bc_pop_over_models_1.Directions.left] = this.positionLeft.bind(this),
                    _a[bc_pop_over_models_1.Directions.right] = this.positionRight.bind(this),
                    _a[bc_pop_over_models_1.Directions.top] = this.positionTop.bind(this),
                    _a[bc_pop_over_models_1.Directions.bottom] = this.positionBottom.bind(this),
                    _a[bc_pop_over_models_1.Directions.topLeft] = this.positionTopLeft.bind(this),
                    _a[bc_pop_over_models_1.Directions.topRight] = this.positionTopRight.bind(this),
                    _a[bc_pop_over_models_1.Directions.bottomRight] = this.positionBottomRight.bind(this),
                    _a[bc_pop_over_models_1.Directions.bottomLeft] = this.positionBottomLeft.bind(this),
                    _a[bc_pop_over_models_1.Directions.rightTop] = this.positionRightTop.bind(this),
                    _a[bc_pop_over_models_1.Directions.rightBottom] = this.positionRightBottom.bind(this),
                    _a[bc_pop_over_models_1.Directions.leftTop] = this.positionLeftTop.bind(this),
                    _a[bc_pop_over_models_1.Directions.leftBottom] = this.positionLeftBottom.bind(this),
                    _a);
                options[positionPopover](position);
            }
        }
        else {
            this.setAutomaticPosition();
        }
    };
    BcPopOverBehavior.prototype.setAutomaticPosition = function () {
        if (this.mySelf.classList.contains(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_ACTIVE)) {
            this.target.appendChild(this.arrowElement);
        }
        var targetOffset = this.elementPosition.getTargetOffset(this.target, this.localization);
        var popOverElement = this.mySelf;
        var viewportOffset = this.getSizeWindows();
        var offset = this.elementPosition.getCoachOffset(this.mySelf, this.localization);
        var position = this.elementPosition.getCoachPosition(this.localizationBuilder, targetOffset, offset, viewportOffset);
        this.elementPosition.evaluateArrowPosition(this.localizationBuilder.position, this.arrowElement, targetOffset);
        this.elementPosition.setElementPosition(position, popOverElement, this.localizationBuilder.position);
        if (this.bcContainer.classList.contains(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_GRAY)) {
            this.arrowElement.classList.add(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_GRAY);
        }
        else {
            this.arrowElement;
        }
    };
    BcPopOverBehavior.prototype.positionLeft = function (position) {
        var middleHeigthPopOver = this.mySelf.getBoundingClientRect().height / common_constants_1.COMMON_CONSTANTS_NUMBERS.N2;
        var widhPopOver = this.mySelf.getBoundingClientRect().width;
        this.stilesPosition((position.x - bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_MARGIN_ARROW), position.y, "left: ".concat(widhPopOver + bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_POSITION_ARROW, "px"), "top: ".concat(middleHeigthPopOver + bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_POSITION_ARROW, "px"), 'transform: rotate(180deg);');
    };
    BcPopOverBehavior.prototype.positionRight = function (position) {
        var middleHeigthPopOver = this.mySelf.getBoundingClientRect().height / common_constants_1.COMMON_CONSTANTS_NUMBERS.N2;
        this.stilesPosition((position.x + bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_MARGIN_ARROW), position.y, "left: -".concat(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_POSITION_ARROW, "px"), "top: ".concat(middleHeigthPopOver - bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_POSITION_ARROW, "px"));
    };
    BcPopOverBehavior.prototype.positionTop = function (position) {
        var heigthPopover = this.mySelf.getBoundingClientRect().height;
        var middleWidhPopOver = this.mySelf.getBoundingClientRect().width / common_constants_1.COMMON_CONSTANTS_NUMBERS.N2;
        this.stilesPosition(position.x, (position.y - bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_MARGIN_ARROW), "left: ".concat(middleWidhPopOver - bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_POSITION_ARROW, "px"), "top: ".concat(heigthPopover + bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_POSITION_ARROW, "px"), 'transform: rotate(270deg);');
    };
    BcPopOverBehavior.prototype.positionBottom = function (position) {
        var middleWidhPopOver = this.mySelf.getBoundingClientRect().width / common_constants_1.COMMON_CONSTANTS_NUMBERS.N2;
        this.stilesPosition(position.x, (position.y + bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_MARGIN_ARROW), "left: ".concat(middleWidhPopOver + bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_POSITION_ARROW, "px"), "top: -".concat(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_POSITION_ARROW, "px"), 'transform: rotate(90deg);');
    };
    BcPopOverBehavior.prototype.positionTopLeft = function (position) {
        var heigthPopover = this.mySelf.getBoundingClientRect().height;
        var referenceWidh = (this.mySelf.getBoundingClientRect().width / bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_N12)
            * bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_N11;
        this.stilesPosition((position.x), (position.y - bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_MARGIN_ARROW), "left: ".concat(referenceWidh - bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_POSITION_ARROW, "px"), "top: ".concat(heigthPopover + bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_POSITION_ARROW, "px"), 'transform: rotate(270deg);');
    };
    BcPopOverBehavior.prototype.positionTopRight = function (position) {
        var heigthPopover = this.mySelf.getBoundingClientRect().height;
        var referenceWidh = this.mySelf.getBoundingClientRect().width / bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_N12;
        this.stilesPosition((position.x), (position.y - bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_MARGIN_ARROW), "left: ".concat(referenceWidh - bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_POSITION_ARROW, "px"), "top: ".concat(heigthPopover + bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_POSITION_ARROW, "px"), 'transform: rotate(270deg);');
    };
    BcPopOverBehavior.prototype.positionBottomRight = function (position) {
        var middleWidhPopOver = this.mySelf.getBoundingClientRect().width / bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_N12;
        this.stilesPosition(position.x, (position.y + bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_MARGIN_ARROW), "left: ".concat(middleWidhPopOver + bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_POSITION_ARROW, "px"), "top: -".concat(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_POSITION_ARROW, "px"), 'transform: rotate(90deg);');
    };
    BcPopOverBehavior.prototype.positionBottomLeft = function (position) {
        var middleWidhPopOver = (this.mySelf.getBoundingClientRect().width / bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_N12)
            * bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_N11;
        this.stilesPosition(position.x, (position.y + bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_MARGIN_ARROW), "left: ".concat(middleWidhPopOver + bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_POSITION_ARROW, "px"), "top: -".concat(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_POSITION_ARROW, "px"), 'transform: rotate(90deg);');
    };
    BcPopOverBehavior.prototype.positionRightTop = function (position) {
        var middleHeigthPopOver = (this.mySelf.getBoundingClientRect().height / bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_N12)
            * bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_N11;
        this.stilesPosition((position.x + bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_MARGIN_ARROW), position.y, "left: -".concat(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_POSITION_ARROW, "px"), "top: ".concat(middleHeigthPopOver - bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_POSITION_ARROW, "px"));
    };
    BcPopOverBehavior.prototype.positionRightBottom = function (position) {
        var middleHeigthPopOver = this.mySelf.getBoundingClientRect().height / bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_N12;
        this.stilesPosition((position.x + bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_MARGIN_ARROW), position.y, "left: -".concat(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_POSITION_ARROW, "px"), "top: ".concat(middleHeigthPopOver - bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_POSITION_ARROW, "px"));
    };
    BcPopOverBehavior.prototype.positionLeftTop = function (position) {
        var middleHeigthPopOver = (this.mySelf.getBoundingClientRect().height / bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_N12)
            * bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_N11;
        var widhPopOver = this.mySelf.getBoundingClientRect().width;
        this.stilesPosition((position.x - bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_MARGIN_ARROW), position.y, "left: ".concat(widhPopOver + bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_POSITION_ARROW, "px"), "top: ".concat(middleHeigthPopOver + bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_POSITION_ARROW, "px"), 'transform: rotate(180deg);');
    };
    BcPopOverBehavior.prototype.positionLeftBottom = function (position) {
        var middleHeigthPopOver = this.mySelf.getBoundingClientRect().height / bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_N12;
        var widhPopOver = this.mySelf.getBoundingClientRect().width;
        this.stilesPosition((position.x - bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_MARGIN_ARROW), position.y, "left: ".concat(widhPopOver + bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_POSITION_ARROW, "px"), "top: ".concat(middleHeigthPopOver + bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_POSITION_ARROW, "px"), 'transform: rotate(180deg);');
    };
    BcPopOverBehavior.prototype.stilesPosition = function (x, y, left, top, rotate) {
        this.mySelf.setAttribute('style', "will-change: transform;\n            position: absolute;\n            transform: translate3d(".concat(Math.round(x), "px, ").concat(Math.round(y), "px, 0px);\n            top: 0px;\n            left: 0px;"));
        this.arrowPopover.setAttribute('style', '');
        this.arrowPopover.setAttribute('style', "position: absolute;\n            ".concat(left, ";\n            ").concat(top, ";\n            ").concat(rotate, ";"));
    };
    BcPopOverBehavior.prototype.positionsMySelf = function () {
        var boundingMySelf = this.mySelf.getBoundingClientRect();
        return {
            width: boundingMySelf.width,
            height: boundingMySelf.height,
            middleWidth: boundingMySelf.width / common_constants_1.COMMON_CONSTANTS_NUMBERS.N2,
            middleHeight: boundingMySelf.height / common_constants_1.COMMON_CONSTANTS_NUMBERS.N2
        };
    };
    BcPopOverBehavior.prototype.createButonClose = function () {
        var _this = this;
        var contentButtonClose = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_CONTENT_CLOSE, bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_FLEX, bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_JUSTIFY_END, bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_MARGIN_TOP, bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_MARGIN_RIGHT]
        });
        var iconButton = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.BUTTON_TAG,
            classList: [bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_ICON_BUTTON, bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_ICON_BUTTON_GHOST, bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_ICON_BUTTON_SMALL],
        });
        var iconClose = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.I_TAG,
            classList: [common_constants_1.BcCommonConstants.ICONS_CLASS],
            innerText: common_constants_1.BcCommonConstants.ICON_ERROR
        });
        iconButton.appendChild(iconClose);
        contentButtonClose.appendChild(iconButton);
        var popOverContainer = this.mySelf.querySelector(".".concat(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_CONTAINER));
        popOverContainer.prepend(contentButtonClose);
        iconButton.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this.closePopOver();
        });
    };
    BcPopOverBehavior.prototype.setScroll = function () {
        this.bcContainer.classList.add(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_SCROLL);
    };
    BcPopOverBehavior.prototype.setWidth = function (typeWidth) {
        if (Number(this.widthAttribute) > bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_CONTAINER_MIN_WIDTH) {
            this.bcContainer.style.setProperty(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_PROPERTY_WIDTH, "".concat(this.widthAttribute).concat(typeWidth));
        }
    };
    BcPopOverBehavior.prototype.setHeight = function (typeHeight) {
        this.bcContainer.style.setProperty(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_PROPERTY_HEIGHT, "".concat(this.heightAttribute).concat(typeHeight));
    };
    BcPopOverBehavior.prototype.createBackdrop = function () {
        if (this.backdropAttribute === bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_VALUE_TRUE) {
            var backdrop = (0, helpers_1.createElement)({
                element: common_constants_1.BcCommonConstants.DIV_TAG,
                classList: [bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_BACKDROP],
            });
            var body = document.body;
            document.body.prepend(backdrop);
            body.classList.add(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_SCROLL_BLOCK);
        }
    };
    BcPopOverBehavior.prototype.removeBackdrop = function () {
        var backdrop = document.querySelector(".".concat(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_BACKDROP));
        if (backdrop) {
            backdrop.remove();
            var body = document.body;
            body.classList.remove(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_SCROLL_BLOCK);
        }
    };
    BcPopOverBehavior.prototype.listenerResize = function () {
        var _this = this;
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_RESIZE, function () {
            _this.setSizeMediaQuery(true);
            if (_this.mySelf.classList.contains(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_ACTIVE)) {
                _this.setPosition();
            }
        });
    };
    BcPopOverBehavior.prototype.listenerScroll = function () {
        var _this = this;
        var containersScroll = document.querySelectorAll(".".concat(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_SCROLL));
        if (containersScroll) {
            containersScroll.forEach(function (container) {
                container.addEventListener(common_constants_1.BcCommonConstants.EVENT_SCROLL, function () {
                    _this.setSizeMediaQuery(true);
                    _this.setPosition();
                });
            });
        }
    };
    BcPopOverBehavior.prototype.listenerMouseEnter = function () {
        var _this = this;
        this.target.addEventListener(common_constants_1.BcCommonConstants.EVENT_MOUSEENTER, function () {
            _this.openPopOver();
        }, true);
    };
    BcPopOverBehavior.prototype.listenerMouseLeave = function () {
        var _this = this;
        this.target.addEventListener(common_constants_1.BcCommonConstants.EVENT_MOUSELEAVE, function () {
            _this.closePopOver();
        });
    };
    BcPopOverBehavior.prototype.listenerCloseEventKey = function () {
        var _this = this;
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ESCAPE) {
                _this.closePopOver();
            }
        });
    };
    BcPopOverBehavior.prototype.listenerClickOut = function () {
        var _this = this;
        document.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            var targetClick = event.target.classList.contains(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_TARGET);
            var element = event.target.offsetParent;
            if (_this.mySelf.classList.contains(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_ACTIVE)) {
                if (element) {
                    var classElement = element.classList.contains(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER);
                    if (!targetClick) {
                        if (!classElement) {
                            _this.closePopOver();
                        }
                    }
                }
            }
        });
    };
    BcPopOverBehavior.prototype.hiddenArrow = function () {
        if (this.hiddenArrowAttribute === bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_VALUE_TRUE) {
            var arrow = this.target.querySelector(".".concat(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_ARROW));
            arrow.style.setProperty(common_constants_1.BcCommonConstants.DISPLAY, common_constants_1.BcCommonConstants.NONE);
        }
    };
    BcPopOverBehavior.prototype.setSizeMediaQuery = function (resize) {
        if (resize) {
            if (this.fullScreenAttribute === bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_VALUE_TRUE) {
                var widthWindow = this.getSizeWindows();
                if (widthWindow.width <= common_constants_1.BcCommonConstants.BREAKPOINT_XS) {
                    this.bcContainer.style.setProperty(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_PROPERTY_WIDTH, "".concat(common_constants_1.COMMON_CONSTANTS_NUMBERS.N100, "vw"));
                    this.bcContainer.style.setProperty(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_PROPERTY_HEIGHT, "".concat(common_constants_1.COMMON_CONSTANTS_NUMBERS.N100, "vh"));
                }
                else {
                    this.setWidth(this.typeWidth);
                    this.setHeight(this.typeHeight);
                }
            }
        }
        else {
            this.setWidth(this.typeWidth);
            this.setHeight(this.typeHeight);
        }
    };
    BcPopOverBehavior.prototype.getSizeWindows = function () {
        return {
            height: window.innerHeight,
            width: window.innerWidth,
        };
    };
    BcPopOverBehavior.prototype.openPopOver = function () {
        this.target.classList.add(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_SCROLL_HIGHLIGHT);
        this.createBackdrop();
        this.mySelf.classList.add(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_ACTIVE);
        this.setPosition();
        this.hiddenArrow();
    };
    BcPopOverBehavior.prototype.tooglePopOver = function () {
        if (this.mySelf.classList.contains(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_ACTIVE)) {
            this.closePopOver();
        }
        else {
            this.openPopOver();
        }
    };
    BcPopOverBehavior.prototype.closePopOver = function () {
        this.mySelf.classList.remove(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_ACTIVE);
        this.removeBackdrop();
        this.arrowElement.remove();
        this.target.classList.remove(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_SCROLL_HIGHLIGHT);
        if (this.target.classList.contains(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_SCROLL_HIGHLIGHT)) {
            this.target.querySelector(".".concat(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_ARROW)).remove();
        }
    };
    return BcPopOverBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcPopOverBehavior = BcPopOverBehavior;
